export const SubscriptionRecipeCheckboxValidation = {
  validateRecipeQuantities() {
    const recipeForm = this.element.querySelector('#recipe-form')
    if (!recipeForm) return true

    const recipeCheckboxes = recipeForm.querySelectorAll(
      'input[type="checkbox"][name="recipe"]'
    )
    if (recipeCheckboxes.length === 0) return true

    const hasSelectedRecipe = Array.from(recipeCheckboxes).some(
      (checkbox) => checkbox.checked
    )
    if (!hasSelectedRecipe) return false

    return Array.from(recipeCheckboxes).every((checkbox) => {
      if (!checkbox.checked) return true

      const lineItem = checkbox.closest('.js-sku-line-item')
      const quantityField = lineItem?.querySelector(
        'input[type="number"][class*="account-recipe-quantity"]'
      )

      if (quantityField) {
        const quantity = parseInt(quantityField.value, 10) || 0
        return quantity > 0
      }

      const hiddenQuantityField = lineItem?.querySelector(
        'input[type="hidden"][data-sku-selector-target="quantity"]'
      )
      if (hiddenQuantityField) {
        const quantity = parseInt(hiddenQuantityField.value, 10) || 0
        return quantity > 0
      }

      return false
    })
  },

  disableSubmitForRecipes() {
    const recipeForm = this.element.querySelector('#recipe-form')
    const hasSelectedRecipe = !!recipeForm?.querySelector(
      'input[name="recipe"]:checked'
    )

    const message = hasSelectedRecipe
      ? 'All selected recipes must have a quantity greater than 0'
      : 'Please select at least one recipe'

    this.setSubmitState(true, message)
  },
}
